import { useEffect, useState } from "react";
import patientController from "../../../../apis/Controllers/PatientController/patient.controller";
import { useNavigate } from "react-router-dom";
import { Toaster } from "../../../Helper/toaster/Toaster";


const PatientListFunctions = () => {
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [patientListing, setPatineListing] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [wardActivePatient, setWardActivePatient] = useState(0);
    const [totalPages, setTotalPages] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [loader, setLoader] = useState(false);

    const [patientStatus, setPatientStatus] = useState([
        { id: 'admitted', value: 'Admitted' },
        { id: 'under_treatment', value: 'Under Treatment' },
        { id: 'critical', value: 'Critical' },
        { id: 'discharge', value: 'Discharged' },
    ]);


    let navigate = useNavigate();

    useEffect(() => {
        if (count) {
            handlePages(count);
        }
    }, [count]);

    const handlePages = (count) => {
        let array = [...totalPages]
        const data = parseInt(count);
        const totalPage = Math.ceil(data / itemsPerPage);
        for (let i = 1; i <= totalPage; i++) {
            array.push(i);
        }
        setTotalPages(array);
    };

    const handleChange = (e, wardId) => {
        setSearchInput(e.target.value);
        getPatientListing(e.target.value, page, wardId);
    };

    const getPatientListing = async (search, page, wardId) => {
        if (!loader) {
            let post = {
                search: search ? search : '',
                page: page ? page : 1,
                ward_id: [wardId]
            }
            setLoader(true)
            let response = await patientController.patientListing(post);
            if (response && response.status) {
                setPatineListing(response.data)
                setCount(response.count);
                setWardActivePatient(response.ward_active_patient);
                setLoader(false)
            }
            else {
                setPatineListing([]);
                setCount(0);
                setWardActivePatient(0);
                setLoader(false)
            }
        }
    };

    const handleBackClick = () => {
        if (page > 1) {
            setPage(page - 1);
        }
        else {
            setPage(1);
        }
    };

    const handleNextClick = () => {
        if (page >= 1 && page < totalPages.length) {
            setPage(page + 1);
        }
        else {
            setPage(page);
        }
    };

    const chnagePatientStatus = async (id, status, wardId) => {
        if (!loader) {
            let post = {
                patient_status: status ? status : '',
            }
            setLoader(true)
            let response = await patientController.updatePatientStatus(id, post);
            if (response && response.status) {
                setLoader(false)
                new Toaster().success(response.message);
                getPatientListing('', page, wardId);
            }
            else {
                setLoader(false)
            }

        }
    };

    return {
        setShowFilterModal,
        showFilterModal,
        setSearchInput,
        searchInput,
        handleChange,
        getPatientListing,
        patientListing,
        navigate,
        loader,
        page,
        handlePages,
        totalPages,
        handleNextClick,
        handleBackClick,
        wardActivePatient,
        patientStatus,
        setPatientStatus,
        chnagePatientStatus

    }
};

export default PatientListFunctions;